export default __webpack_public_path__ + "static/contact-54a26cc32192d9bd6e041da902865a7e.png";